import { Seo } from "../lib/seo";

export const PageStub = ({ title, description, path }) => (
  <>
    <Seo title={title} description={description} path={path} noindex />
    <section className="page-hero">
      <div className="page-hero-inner">
        <span className="section-eyebrow">Coming next</span>
        <h1>{title}</h1>
        <p className="page-hero-sub">{description}</p>
      </div>
    </section>
  </>
);
